var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6011 38.4648H10.6011C9.54021 38.4648 8.52279 38.0434 7.77265 37.2933C7.0225 36.5431 6.60107 35.5257 6.60107 34.4648V14.4648M6.60107 14.4648C6.60107 13.404 7.0225 12.3866 7.77265 11.6364C8.52279 10.8863 9.54021 10.4648 10.6011 10.4648H38.6011C39.6619 10.4648 40.6794 10.8863 41.4295 11.6364C42.1796 12.3866 42.6011 13.404 42.6011 14.4648M6.60107 14.4648L24.6011 26.4648L42.6011 14.4648M42.6011 14.4648V25.4648M32.6011 38.4648H44.6011M38.6011 32.4648V44.4648",
    stroke: "#31B9B5",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.c88214954e86eff9eba90e4f9d9a1d0d.svg";
export { ForwardRef as ReactComponent };